module.exports = __webpack_public_path__ + "media/images/diy/removebg-preview-e5fe768fc552e5e96a1e8ed9e60b901a.svg";